import React, { type FC } from 'react'

interface IconEnvelopeProps {
  width?: string
  height?: string
}

const IconEnvelope: FC<IconEnvelopeProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.25 3.9375C1.94062 3.9375 1.6875 4.19062 1.6875 4.5V5.27695L7.75195 10.2551C8.47969 10.8527 9.52383 10.8527 10.2516 10.2551L16.3125 5.27695V4.5C16.3125 4.19062 16.0594 3.9375 15.75 3.9375H2.25ZM1.6875 7.46016V13.5C1.6875 13.8094 1.94062 14.0625 2.25 14.0625H15.75C16.0594 14.0625 16.3125 13.8094 16.3125 13.5V7.46016L11.3203 11.5594C9.97031 12.6668 8.02617 12.6668 6.67969 11.5594L1.6875 7.46016ZM0 4.5C0 3.25898 1.00898 2.25 2.25 2.25H15.75C16.991 2.25 18 3.25898 18 4.5V13.5C18 14.741 16.991 15.75 15.75 15.75H2.25C1.00898 15.75 0 14.741 0 13.5V4.5Z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </svg>
  )
}

export default IconEnvelope
